import { proxy } from 'valtio';

export const profileStore = proxy({
  profile: null,
  expertise: null,
  isProfileLoading: false,
  isExpertiseLoading: false,
  isError: false,
  error: null,

  setProfile(profile) {
    profileStore.profile = profile;
  },

  setExpertise(expertise) {
    profileStore.expertise = expertise;
  },

  setProfileLoading(loading) {
    profileStore.isProfileLoading = loading;
  },

  setExpertiseLoading(loading) {
    profileStore.isExpertiseLoading = loading;
  },

  setError(error) {
    profileStore.error = error;
    profileStore.isError = !!error;
  },

  reset() {
    profileStore.profile = null;
    profileStore.expertise = null;
    profileStore.isProfileLoading = false;
    profileStore.isExpertiseLoading = false;
    profileStore.isError = false;
    profileStore.error = null;
  },
});
